// Mapeia os eventos do Meta Pixel para os eventos recomendados do GA4,
// para que cada chamada de trackMetaEvent() reporte a conversão nas duas
// plataformas ao mesmo tempo (Meta Ads e Google Analytics).
const GA4_EVENT_MAP = {
  CompleteRegistration: 'sign_up',
  InitiateCheckout: 'begin_checkout',
  Purchase: 'purchase',
};

function trackGA4Event(metaEventName, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const ga4Name = GA4_EVENT_MAP[metaEventName];
  if (!ga4Name) return;
  const ga4Params = {};
  if (params?.content_name) ga4Params.content_name = params.content_name;
  if (params?.value != null) ga4Params.value = params.value;
  if (params?.currency) ga4Params.currency = params.currency;
  window.gtag('event', ga4Name, ga4Params);
}

// `eventId`: o mesmo event_id enviado pela Conversions API (servidor), para a
// Meta contar uma conversão só quando chegar pelos dois caminhos.
export function trackMetaEvent(eventName, params, eventId) {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq === 'function') {
    if (eventId) {
      window.fbq('track', eventName, params || {}, { eventID: eventId });
    } else if (params && Object.keys(params).length) {
      window.fbq('track', eventName, params);
    } else {
      window.fbq('track', eventName);
    }
  }
  trackGA4Event(eventName, params);
}
